import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import licensesEpics from './Licenses/epics'
import {
  delCompanyLogoError,
  delCompanyLogoSuccess,
  getGeneralSettingsError,
  getGeneralSettingsSuccess,
  updateGeneralSettingsError,
  updateGeneralSettingsSuccess,
} from './actions'
import {
  DEL_LOGO_REQUEST,
  GENERAL_SETTINGS_REQUEST_ASYNC,
  UPDATE_GENERAL_SETTINGS_REQUEST,
} from './constants'

const getGeneralSettingsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      DEL_LOGO_REQUEST.SUCCESS,
      GENERAL_SETTINGS_REQUEST_ASYNC.INITIATE,
      UPDATE_GENERAL_SETTINGS_REQUEST.SUCCESS
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.general)
      return true
    }),
    mergeMap(() =>
      api.settings.getGeneralSettings(state$.value.partnerOptions.selectedCompany?.value).pipe(
        map((response) => getGeneralSettingsSuccess(response)),
        catchError((error) => of(epicsErrorHandler(getGeneralSettingsError, error))),
        takeUntil(action$.pipe(ofType(GENERAL_SETTINGS_REQUEST_ASYNC.CANCEL)))
      )
    )
  )

const updateGeneralSettingsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(UPDATE_GENERAL_SETTINGS_REQUEST.INITIATE),
    mergeMap((action) => {
      const payload = {
        ...state$.value.form.GeneralSettingsForm.values,
        ...action.payload,
      }
      return api.settings
        .updateGeneralSettings(state$.value.partnerOptions.selectedCompany?.value, payload)
        .pipe(
          map(() => updateGeneralSettingsSuccess(payload)),
          catchError((error) => of(epicsErrorHandler(updateGeneralSettingsError, error))),
          takeUntil(action$.pipe(ofType(UPDATE_GENERAL_SETTINGS_REQUEST.CANCEL)))
        )
    })
  )

const delCompanyLogoEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(DEL_LOGO_REQUEST.INITIATE),
    mergeMap(() =>
      api.settings.delCompanyLogo().pipe(
        map((response) => delCompanyLogoSuccess(response)),
        catchError((error) => of(epicsErrorHandler(delCompanyLogoError, error))),
        takeUntil(action$.pipe(ofType(DEL_LOGO_REQUEST.CANCEL)))
      )
    )
  )

export default combineEpics(
  getGeneralSettingsEpic,
  updateGeneralSettingsEpic,
  delCompanyLogoEpic,
  licensesEpics
)
